/* eslint-disable */
import React from 'react'
import PremiumMassageItem from "./premium-massage-item"
import { TitleOne, TextBodyOne } from '../../components/text'

import { Grid, Row, Col } from 'react-flexbox-grid'
import { useTranslation } from "react-i18next";

import { Style } from './premium-massage.styles'
import premiumMessageServices from '../../constants/premium-massage-services'


const renderContentPremium = (services, setServices) => (
  services.map(content => (
    <Col
      key={content.id}
      sm={12}
      xs={12}
      lg={12}
      className="smaller-hover bottom"
    >
      <PremiumMassageItem
        options={content}
        showDetailWork={content.show}
        onPressDetailWork={() => {
          let updatedList = services.map(item => 
            {
              if (item.id == content.id){
                return {...item, show: !item.show};
              }
              return item;
            });
          setServices(updatedList)
        }}
      />
    </Col>
  ))
)

const ServiceMassage = () => {
  const { t } = useTranslation();
  const [services, setServices] = React.useState(premiumMessageServices)

  return (
    <Style>
      <Grid>
        <Row>
          <Col
            sm={12}
            xs={12}
            lg={12}
            className="column-margin"
          >
            <TitleOne display="block" align="center">
              {t('pageBodyMassageJakarta.part17')}
            </TitleOne>
            <TextBodyOne display="block" align="center">
              {t('pageBodyMassageJakarta.part18')}
            </TextBodyOne>
          </Col>
        </Row>
        <Row>
          {renderContentPremium(services, setServices)}
        </Row>
      </Grid>
    </Style>
  )
}

export default ServiceMassage
